import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";

export function PaywallSheet({ open, reason, onClose }) {
  const navigate = useNavigate();
  return (
    <Drawer open={open} onOpenChange={(o) => !o && onClose()}>
      <DrawerContent className="mx-auto max-w-md rounded-t-3xl border-0 px-6 pb-8" style={{ background: "var(--ga-card)" }} data-testid="paywall-sheet">
        <div className="mx-auto mt-2 flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: "#05324A" }}><Sparkles color="#33D9B2" /></div>
        <DrawerTitle className="mt-4 text-center text-xl font-semibold">Guarde ainda mais.</DrawerTitle>
        <DrawerDescription className="ga-muted text-center text-sm">{reason}</DrawerDescription>
        <div className="mt-5 flex gap-3">
          <button onClick={onClose} className="ga-btn-ghost flex-1" data-testid="paywall-sheet-continue-free">Continuar grátis</button>
          <button onClick={() => { onClose(); navigate("/planos"); }} className="ga-btn-primary flex-1" data-testid="paywall-sheet-see-plans">Ver planos</button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
